import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { CustomerPersonItem } from '@app/services/economy.service';
import { BusinessItem, CoopItem, CountryItem } from '@app/services/logistic.service';
import { OrderHeadCustomerFormGroup, OrderHeadDeliveryFormGroup, OrderHeadInvoiceFormGroup } from '../../order-head-edit/order-head-edit.component';

@Component({
    selector: 'tt-order-head-address-form',
    templateUrl: './order-head-address-form.component.html',
    styleUrls: ['./order-head-address-form.component.css'],
})
export class OrderHeadAddressFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public customerForm?: FormGroup<OrderHeadCustomerFormGroup>;

    @Input()
    public deliveryForm?: FormGroup<OrderHeadDeliveryFormGroup>;

    @Input()
    public invoiceForm?: FormGroup<OrderHeadInvoiceFormGroup>;

    @Input()
    public customerPersons: CustomerPersonItem[] = [];

    @Input()
    public businesses: BusinessItem[] = [];

    @Input()
    public coops: CoopItem[] = [];

    @Input()
    public countries: CountryItem[] = [];
}
